module.exports = __webpack_public_path__ + "static/media/23.935109d7.mp3";